import React,{useEffect,useState} from 'react';
import DataTable from '../../components_shared/DataTable';
import api, { apiBaseUrl } from '../../utils/api';

export default function ReceiptsPage(){
  const [rows,setRows]=useState([]); const [loading,setLoading]=useState(true); const [error,setError]=useState(null);
  useEffect(()=>{(async()=>{
    try{
      const res=await api.get('/api/v1/inventory/dispatch-notes',{params:{status:'RECEIVED_FINAL',page:0,size:50,sort:'id,desc'}});
      setRows(res.data.content||[]);
    }catch(e){setError(e.message);}finally{setLoading(false);} })();},[]);

  const cols=[
    {accessorKey:'referenceNo',header:'Ref #'},
    {accessorKey:'workOrderNo',header:'Work Order'},
    {accessorKey:'quantity',header:'Qty'},
    {accessorKey:'truckNumber',header:'Truck #'},
    {accessorKey:'status',header:'Status'},
    {id:'pdf',header:'PDF',cell:({row})=> (
        <a href={`${apiBaseUrl}/api/v1/inventory/dispatch-notes/${row.original.id}/pdf`} target="_blank" rel="noreferrer">📄</a>
      )},
  ];

  if(loading) return <p>Loading...</p>; if(error) return <div className='alert alert-danger'>{error}</div>;
  return <div className='container pt-4'><h3>Receipts</h3><DataTable data={rows} columns={cols}/></div>;
}
